declare namespace $ {

	export class $shm_hitalama_map_widget_float_code_js extends $shm_hitalama_map_widget_float_code {
		textarea_hint( ): string
	}
	
}

//# sourceMappingURL=js.view.tree.d.ts.map